var exports = {
  "kL": "xe533113f--a08404--container",
  "vK": "xe533113f--a08404--banner",
  "QH": "xe533113f--a08404--banner--red",
};

module.exports = exports;
